import rules from "../../utils/rules";
import apiService from "../../api/api.service";
import { mapGetters } from "vuex";
export default {
  name: "first-time-change-password",
  data() {
    return {
      rules: rules,
      valid: true,
      oldPassword: null,
      confirmPassword: null,
      newPassword: null,
      loading: false,
      showOldpass: true,
      showConfirmpass: true,
      showNewpass: true,
      confirmPasswordRules: [
        (value) => !!value || "Confirm password is required",
        (value) =>
          value === this.newPassword ||
          "The password confirmation does not match.",
      ],
    };
  },
  computed: {
    ...mapGetters(["id"]),
  },
  methods: {
    async changePassword() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let payload = {
            oldPassword: this.oldPassword,
            newPassword: this.newPassword,
          };
          let response = await apiService.changepassword(payload, this.id);
          if (response.isSuccess) {
            this.loading = false;
            this.$toast.success("Password changed successfully");
            this.$store.commit("SET_FIRST_TIME_LOGIN", false);

            //redirect to login page
            this.$store.dispatch("LogOut");
            this.$router.push("/login");
          } else {
            this.loading = false;
            this.$toast.error(response.systemMessage);
          }
        } catch (error) {
          this.$toast.error("Unable to update the password" + error);
          this.loading = false;
        }
      }
    },
    backToLogin() {
      this.$store.dispatch("LogOut");
      this.$router.push("/login");
    },
  },
};
